import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';

const EnabledUsersTable = ({ users, loader, setUserToEditRoles, setUserToDisable, handleViewAudit }) => {
  const [selectedUser, setSelectedUser] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const usersdata = users || [];

  const handleMenuOpen = (rowData, event) => {
    setSelectedUser(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const filteredUsers = usersdata.filter(function(user) {
    if (!searchTerm) return true;
    var searchLower = searchTerm.toLowerCase();
    return (
      (user.firstName && user.firstName.toLowerCase().indexOf(searchLower) !== -1) ||
      (user.lastName && user.lastName.toLowerCase().indexOf(searchLower) !== -1) ||
      (user.username && user.username.toLowerCase().indexOf(searchLower) !== -1) ||
      (user.email && user.email.toLowerCase().indexOf(searchLower) !== -1)
    );
  });

  var paginatedUsers = filteredUsers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (loader) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
        <Typography variant="h6" style={{ marginLeft: 16 }}>
          Loading users...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search users by name, username, or email..."
        value={searchTerm}
        onChange={handleSearchChange}
        size="small"
        sx={{ mb: 2 }}
      />
      <TableContainer component={Paper}>
        <Table aria-label="active users table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: '#003643', color: '#FFF', fontWeight: 'bold' }}>First Name</TableCell>
              <TableCell sx={{ backgroundColor: '#003643', color: '#FFF', fontWeight: 'bold' }}>Last Name</TableCell>
              <TableCell sx={{ backgroundColor: '#003643', color: '#FFF', fontWeight: 'bold' }}>Username</TableCell>
              <TableCell sx={{ backgroundColor: '#003643', color: '#FFF', fontWeight: 'bold' }}>Email</TableCell>
              <TableCell sx={{ backgroundColor: '#003643', color: '#FFF', fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedUsers.map(function(user, index) {
              return (
                <TableRow key={user.id || index} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                  <TableCell>{user.firstName || ''}</TableCell>
                  <TableCell>{user.lastName || ''}</TableCell>
                  <TableCell>{user.username || ''}</TableCell>
                  <TableCell>{user.email || ''}</TableCell>
                  <TableCell>
                    <IconButton onClick={function(event) { handleMenuOpen(user, event); }} size="small">
                      <MoreVertIcon />
                    </IconButton>
                    {selectedUser.id === user.id && (
                      <Menu
                        id="active-user-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={function() { setAnchorEl(null); setUserToEditRoles(user); }}>
                          Edit User Roles
                        </MenuItem>
                        <MenuItem onClick={function() { setAnchorEl(null); setUserToDisable(user); }}>
                          Disable User
                        </MenuItem>
                        <MenuItem onClick={function() { setAnchorEl(null); handleViewAudit(user); }}>
                          View User Activity
                        </MenuItem>
                      </Menu>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
            {paginatedUsers.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body1" color="textSecondary">
                    {searchTerm ? 'No users found matching your search.' : 'No active users found. Click the Add button to create a new user.'}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={filteredUsers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
};

export default EnabledUsersTable;
